const actionTypes = {
  GET_SINGLE_COUPON_REQUEST: 'checkout/GET_SINGLE_COUPON_REQUEST',
  GET_SINGLE_COUPON_SUCCESS: 'checkout/GET_SINGLE_COUPON_SUCCESS',
  GET_SINGLE_COUPON_ERROR: 'checkout/GET_SINGLE_COUPON_ERROR',
  COUPON_NOT_VALID: 'checkout/COUPON_NOT_VALID',
  INVALIDATE_COUPON: 'checkout/INVALIDATE_COUPON',
} as const;

export default actionTypes;
